import { useEffect, useState } from "react";
import usePassword from "../hooks/usePassword";

export default function Password() {
  const {
    password,
    setPassword,
    handleSubmit,
    isValid,
    firstName,
  } = usePassword();

  const [Button, setButton] = useState<any>(null);

  const [Input, setInput] = useState<any>(null);

  useEffect(() => {
    import("remote_app/Button").then((mod) => {
      setButton(() => mod.default);
    });

    import("inputfield/Input").then((mod) => {
      setInput(() => mod.default);
    });
  }, []);

  if (!Button || !Input) {
    return <div>Loading...</div>;
  }

  return (
    <div className="w-full max-w-[280px] md:max-w-[511px] mx-auto flex flex-col justify-center">
      <h2 className="text-center text-[18px] md:hidden font-medium mb-6">
        Login
      </h2>

      <h2 className="text-[18px] md:text-[20px] font-medium mb-6 max-w-[350px] truncate">
        Hi {firstName}
      </h2>

      <div className="relative w-full">
        <Input
          token="my-secret-token"
          value={password}
          onChange={setPassword}
          type="password"
          placeholder="Enter your Password"
         
          className="w-full h-[45px] md:h-[51px] rounded-xl border px-4 pr-10"
        />
      </div>

      <Button
        token="my-secret-token"
        onClick={handleSubmit}
        disabled={!isValid}
        className={`mt-10 w-full h-[45px] md:h-[51px] rounded-xl font-bold font-montserrat ${
          isValid
            ? "bg-[#CF0018] text-white"
            : "bg-gray-300 text-[#827C7C]"
        }`}
      >
        Login
      </Button>
    </div>
  );
}